import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ListIcon(props: IconProps) {
    return <Icon {...props} iconKey={"list"}/>
}
